
export interface SnippetPart {
  text: string;
  mark: boolean;
}

const unescape = (s: string) =>
  s.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&');

export function parseSnippet(html: string): SnippetPart[] {
  return html
    .split(/<\/?mark>/)
    .map((part, i) => ({ text: unescape(part.replace(/\s+/g, ' ')), mark: i % 2 === 1 }))
    .filter((p) => p.text.length > 0);
}
